import { Text } from '#app/components/Primitives/Text.js';
import { css, styled } from 'styled-components';

export const DescriptionContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 800px;
  word-break: break-word;
`;

export const DescriptionText = styled(Text).attrs({
  textStyle: 'bodyRegular',
})`
  display: inline-block;
`;

export const ViewMoreButton = styled.button`
  ${({ theme }) => css`
    border: none;
    color: ${theme.colorsV2.gray60};
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    padding: 0 4px;
  `}
`;
